<template lang="pug">
app-layout
  v-snackbar(:value='customAudienceGeneralErrorMessage', color='error')
    div {{ customAudienceGeneralErrorMessage }}
  v-snackbar(v-model='showCustomAudienceMessage', color='success')
    div Custom audience created successfully.
  v-snackbar(v-model='showCustomAudienceErrorMessage', color='error')
    div {{ customAudienceErrorMessage }}
  v-snackbar(v-model='showPaymentError', color='error')
    div {{ paymentError }}
  v-snackbar(v-model='checkoutSuccess', color='success')
    div {{ checkoutSuccessMessage }}
  slide-drawer(
    ref='slideDrawerAudience',
    v-model='showSlideDrawerCustomAudience',
    :confirm-dismiss='confirmDismiss'
  )
    template(slot='title')
      span Sync FB Custom Audience
        v-chip.ma-2(color='orange darken-2', text-color='white') BETA
    template(slot='content')
      custom-audience-fb(
        ref='customAudience',
        @input='confirmDismiss = true',
        @changes-saved='closeSlideDrawer',
        @valid-form='validFormCreateCustomAudience',
        @connect-to-facebook='showFacebookDrawer = true'
      )
    template(slot='actionsCustom')
      .slider-actions.justify-end
        v-btn(flat, color='primary', @click='onCustomAudienceFbCancel()') Cancel
        v-btn.primary(
          @click.stop='saveCustomAudience()',
          :disabled='!isValidFormCustomAudienceFb'
        ) Save
  facebook-drawer(
    v-model='showFacebookDrawer',
    @successfully-connected='reloadPersonalFbData()',
    @successfully-disconnected='findEmailLists()'
  )
  v-dialog(v-model='showGetStarted', width='800')
    v-card.coming-soon-dialog
      v-card-title.card_title_icon Coming soon
      v-card-text 
        p {{ getStartedText.mainText }}
        ol
          li(v-for='bulletPoint in getStartedText.bulletPoints', v-html='bulletPoint')
      v-card-actions
        v-layout(pa-0, row, justify-end)
          v-btn(color='primary', @click='closeGetStartedNotification') Ok
  liondesk-dialog(
    :dialog-title='customAudiencesErrorDetails.title',
    :value='showCustomAudiencesError',
    :hideCancelButton='true',
    okButtonText='close',
    @click:ok='hideCustomAudienceErrorDialog()'
  )
    template(slot='body')
      div(v-if='customAudiencesErrorDetails.singleMessage')
        p(v-html='customAudiencesErrorDetails.singleMessage')
      div(v-else)
        p.fb-error-dialog-message(v-html='customAudiencesErrorDetails.message')
        a.fb-error-dialog-link(:href='customAudiencesErrorDetails.link', target='_blank') {{ customAudiencesErrorDetails.linkWording }}
  download-ad-report-modal(
    v-model='showDownloadAdReportModal',
    @close='showDownloadAdReportModal = false'
  )
  plans-landing-pages(
    v-if='showLandingPagesDialog',
    :dialog='showPlans',
    :hideLandingPagesDialog='hideLandingPagesDialog'
  )
  page-payment-modal(v-if='showPageHosted', :dialog='showPageHosted')
  add-payment(v-if='showAddPayment', :dialog='showAddPayment')
  detail-plan-selected(v-if='showDetailPlanSelected', :dialog='showDetailPlanSelected')
  trial-upgrade-modal(
    v-if='showTrialUpgradeModal'
    v-show='showTrialUpgradeModal'
    @hide='showTrialUpgradeModal = false'
  )
  v-container(dark, fluid, grid-list-xl)
    v-layout.card-content(row, wrap)
      marketing-card(v-if="!isBrokerDemoAccount" :properties='marketingConfig.facebookBusinessAdAccountProperties')
        template(slot='icon')
          v-icon(x-large, color='primary') $vuetify.icons.facebook
        template(slot='chip')
          v-chip.ma-2(color='orange darken-2', text-color='white') BETA
        template(slot='actions')
          v-btn(color='primary', @click='showCreateCustomAudience') Sync

      marketing-card(:properties="marketingConfig.boostMarketingPlatformProperties")
        template(slot='icon')
          v-icon.text-lg-center(color='primary') $vuetify.icons.boost
        template(slot='actions')
          v-btn.mb-3(
            color='primary',
            @click='openBoostDashboard'
          ) Design Your Ad

      marketing-card(:properties='marketingConfig.breakthroughBrokerProperties')
        template(slot='icon', color='primary')
          v-icon.text-lg-center(x-large, color='primary') $vuetify.icons.mailbox
        template(slot='actions', color='primary')
          v-btn(@click='startBreakthroughBroker', color='primary') Get Started

      marketing-card(
        v-if="landingPagesAddon"
        :properties='marketingConfig.landingPages'
      )
        template(slot='icon')
          v-icon.text-lg-center(x-large, color='primary') menu_book
        template(slot='actions')
          v-layout(row, wrap, justify-center)
            v-flex.xs12
              v-btn(@click='startLandingPages', color='primary') {{ landingPagesButtonText() }}
            v-flex.xs12(v-if='landingPagesAddon || checkoutIsSuccessful')
              v-btn(@click='goToLandingPages', color='primary') Take me to Landing Pages
      marketing-card(
        v-if="!isBrokerDemoAccount"
        :properties='marketingConfig.leadsPlusMarketingPlataformProperties'
      )
        template(slot='icon')
          v-icon.text-lg-center(x-large, color='primary' class='leadsplus-icon') $vuetify.icons.leads-plus
        template(slot='actions')
            v-btn(@click='openLeadsPlusAccountManagement', color='primary') {{leadPlusButtonText}}
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import { HC_PROPS } from 'lion-vue';
import MarketingCard from './components/MarketingCard';
import MARKETING_CONFIG from './config';
import CustomAudienceFb from '../Contacts/components/CustomAudienceFb';
import SlideDrawer from '@/Core/components/SlideDrawer';
import toggleSlideDrawer from '@/Core/mixins/toggle-slide-drawer';
import FacebookDrawer from '@/Core/components/marketing/FacebookDrawer';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import { BOOST_CONNECTED } from '@/Marketing/config/boost-constants';

export default {
  name: 'MarketingIndex',
  components: {
    CustomAudienceFb,
    MarketingCard,
    SlideDrawer,
    FacebookDrawer,
    LiondeskDialog,
    TrialUpgradeModal: () =>
      import(
        /*webpackChunkName: 'TrialUpgradeModal' */
        '@/Marketing/components/TrialUpgradeModal'
      ),
    PlansLandingPages: () =>
      import(
        /*webpackChunkName: 'PlansLandingPages' */ '@/Core/components/marketing/PlansLandingPages'
      ),
    PagePaymentModal: () =>
      import(
        /* webpackChunkName: 'PagePaymentModal' */ '@/Core/components/marketing/PagePaymentModal'
      ),
    AddPayment: () =>
      import(/* webpackChunkName: 'AddPayment' */ '@/Core/components/marketing/AddPayment'),
    DetailPlanSelected: () =>
      import(
        /* webpackChunkName: 'DetailPlanSelected' */
        '@/Core/components/marketing/DetailPlanSelected'
      ),
    DownloadAdReportModal: () =>
      import(
        /* webpackChunkName: 'DownloadAdReportModal' */
        '@/Marketing/components/DownloadAdReportModal'
      ),
  },
  mixins: [toggleSlideDrawer],
  data() {
    return {
      showGetStarted: false,
      getStartedText: {},
      marketingConfig: MARKETING_CONFIG,
      isValidFormCustomAudienceFb: false,
      showFacebookDrawer: false,
      showDownloadAdReportModal: false,
      showLandingPagesDialog: false,
      checkoutSuccess: false,
      checkoutSuccessMessage: 'Checkout was successful',
      showTrialUpgradeModal: false,
      timerLeadsPlusIntegration: null,
    };
  },
  async created() {
    await this.loadEmailLists();
    if (!this.isConnectedToBoost()) await this.connect();
  },
  beforeCreate() {
    const { query } = this.$route;
    if (query && query.signout === 'true') {
      const ref = document.location.href;
      window.$cookies.set('LD_REDIRECT_URL', ref, null, null, HC_PROPS.MAIN_DOMAIN);
      window.$cookies.remove('LD_AUTH', null, HC_PROPS.MAIN_DOMAIN);
      window.$cookies.remove('feathers-jwt', null, HC_PROPS.MAIN_DOMAIN);
      window.$cookies.remove('RL6Token', null, HC_PROPS.MAIN_DOMAIN);
      window.location = `${HC_PROPS.ACCOUNTS_APP_URL}/signin`;
    }
  },
  mounted() {
    this.onCustomAudienceFbCancel();
    this.$nextTick(function () {
      const { audience } = this.$route.query;
      if (audience && audience === 'facebook') {
        this.showCreateCustomAudience();
      }
    });
    this.getUserAddons();
    if (this.checkoutIsSuccessful) {
      this.checkoutSuccess = true;
    }
    this.handleLeadsPlusIntegrationStatus();
  },
  destroyed() {
    this.clearTimerLeadsPlusIntegrationStatus();
  },
  watch: {
    async isCustomAudienceCreated(isCreated) {
      if (isCreated) {
        await this.findEmailLists();
        this.onCustomAudienceFbCancel();
      }
    },
    user(value) {
      if (value) {
        const { query } = this.$route;
        if (query.modal === 'landing-pages') {
          this.startLandingPages();
        }
      }
    },
  },
  computed: {
    ...mapState({
      isShownCreateCustomAudienceFb: state => state.contactsTable.isShownCreateCustomAudienceFb,
      isCustomAudienceCreated: state => state.contactsTable.isCustomAudienceCreated,
      showCustomAudienceErrorMessageState: state =>
        state.facebookBusiness.showCustomAudienceErrorMessage,
      customAudienceErrorMessage: state => state.facebookBusiness.customAudienceErrorMessage,
      customAudiencesErrorDetails: state => state.customAudiences.customAudiencesErrorDetails,
      showCustomAudiencesError: state => state.customAudiences.showCustomAudiencesError,
      customAudienceGeneralErrorMessage: state =>
        state.customAudiences.customAudienceGeneralErrorMessage,
      showPlans: state => state.payment.showPlans,
      showPageHosted: state => state.payment.showPageHosted,
      showDetailPlanSelected: state => state.payment.showDetailPlanSelected,
      showAddPayment: state => state.payment.showAddPayment,
      landingPagesJWT: state => state.payment.landingPagesJWT,
      paymentError: state => state.payment.paymentError,
      user: state => state.userInformation.user,
    }),
    ...mapGetters('userInformation', ['userHasFeatureFlag']),
    ...mapGetters('payment', ['landingPagesAddon']),
    ...mapGetters('boost', ['connectionStatus']),
    ...mapGetters('leadsplus', ['isIntegrationConnected']),
    showSlideDrawerCustomAudience: {
      get() {
        return this.isShownCreateCustomAudienceFb;
      },
      set(isShown) {
        this.setCreateCustomAudienceFb(isShown);
      },
    },
    showCustomAudienceMessage: {
      get() {
        return this.isCustomAudienceCreated;
      },
      set(val) {
        this.setIsCustomAudienceCreated(val);
      },
    },
    showCustomAudienceErrorMessage: {
      get() {
        return this.showCustomAudienceErrorMessageState;
      },
      set(val) {
        this.setShowCustomAudienceErrorMessage(val);
      },
    },
    userHasAdReportFeatureFlag() {
      return this.userHasFeatureFlag('ad_report_download');
    },
    showPaymentError: {
      get() {
        return this.paymentError;
      },
      set(val) {
        if (!val) {
          this.hidePaymentError();
        }
      },
    },
    checkoutIsSuccessful() {
      const { query } = this.$route;
      return query.checkout === 'success' && query.state === 'succeeded';
    },
    leadPlusButtonText() {
      if(this.isIntegrationConnected) {
        return 'MANAGE YOUR LEADS+ ACCOUNT';
      }
      return 'TAKE ME TO LEADS+';
    },
    isBrokerDemoAccount() {
      return this.user && this.userHasFeatureFlag("brokers_sales_demo");
    },
  },
  methods: {
    ...mapMutations('contactsTable', ['setCreateCustomAudienceFb', 'setIsCustomAudienceCreated']),
    ...mapMutations('facebookBusiness', ['setShowCustomAudienceErrorMessage']),
    ...mapMutations('customAudiences', [
      'setShowCustomAudiencesError',
      'setCustomAudiencesErrorDetails',
    ]),
    ...mapActions('contactsTable', ['findEmailLists', 'loadEmailLists']),
    ...mapActions('payment', [
      'setShowPlans',
      'getUserAddons',
      'getLandingPagesJWT',
      'hidePaymentError',
    ]),
    ...mapActions('boost', ['connect', 'dashboard', 'leadsPlusDashboard']),
    ...mapActions('leadsplus', ['getIntegrationStatus']),
    startFacebookMarketing() {
      this.getStartedText = MARKETING_CONFIG.facebookMessage;
      this.showGetStarted = true;
    },
    showCreateCustomAudience() {
      this.setCreateCustomAudienceFb(true);
    },
    startFacebookMarketingPlatform() {
      this.$router.push('/facebook-ads-get-started');
    },
    startGoogleAds() {
      this.getStartedText = MARKETING_CONFIG.googleAdsMessage;
      this.showGetStarted = true;
    },
    startBreakthroughBroker() {
      this.$router.push('/breakthrough');
    },
    startLandingPages() {
      if (this.user.subscriptionOverview.txt_status !== 'subscribed') {
        this.showTrialUpgradeModal = true;
      } else {
        this.showLandingPagesDialog = true;
        this.setShowPlans(true);
      }
    },
    async goToLandingPages() {
      // commenting this out for new per convrrt's request, but will likely reimplement later
      // await this.getLandingPagesJWT();
      // setCookie('_pages_session', this.landingPagesJWT);
      window.location = process.env.VUE_APP_LANDING_PAGES_URL;
    },
    hideLandingPagesDialog() {
      this.showLandingPagesDialog = false;
    },
    closeGetStartedNotification() {
      this.showGetStarted = false;
      this.getStartedText = {};
    },
    validFormCreateCustomAudience(isValid) {
      this.isValidFormCustomAudienceFb = isValid;
    },
    onCustomAudienceFbCancel() {
      this.$refs.slideDrawerAudience.handleDismiss();
      this.$refs.customAudience.clearFields();
    },
    reloadPersonalFbData() {
      this.$refs.customAudience.getFbData(true);
    },
    async saveCustomAudience() {
      this.isValidFormCustomAudienceFb = false;
      await this.$refs.customAudience.saveCustomAudience();
      this.isValidFormCustomAudienceFb = true;
    },
    hideCustomAudienceErrorDialog() {
      this.setShowCustomAudiencesError(false);
      this.setCustomAudiencesErrorDetails({});
    },
    openDownloadAdReportModal() {
      this.showDownloadAdReportModal = true;
    },
    landingPagesButtonText() {
      return this.landingPagesAddon || this.checkoutIsSuccessful
        ? 'Manage Subscription'
        : 'Get Started';
    },
    isConnectedToBoost() {
      return this.connectionStatus === BOOST_CONNECTED;
    },
    async openBoostDashboard() {
      const { redirect_url: redirectURL } = await this.dashboard(this.user);
      window.open(redirectURL, '_blank');
      return;
    },
    async openLeadsPlusAccountManagement() {
      this.$router.push('/accountmanagement');
    },
    handleLeadsPlusIntegrationStatus() {
      if(!this.isIntegrationConnected) {
        this.timerLeadsPlusIntegration = setInterval(async () => {
          await this.getIntegrationStatus(true);
          if(this.isIntegrationConnected) {
            this.clearTimerLeadsPlusIntegrationStatus();
          }
        }, 5000);
      }
    },
    clearTimerLeadsPlusIntegrationStatus() {
      clearInterval(this.timerLeadsPlusIntegration);
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card.marketing-card .v-btn {
  min-width: 11.8vw;
  margin: 0;
}
.v-btn-ad-portal {
  height: 64px;
  width: 90%;
}
.v-card.coming-soon-dialog {
  .v-card__text ol {
    padding: 0 16px;
    li {
      list-style-type: none;
      min-width: 250px;
      min-height: 35px;
      &:before {
        font-family: Material Icons;
        font-weight: 400;
        content: 'check_circle';
        color: var(--v-background-base);
        padding: 2px 4px;
        vertical-align: middle;
      }
    }
  }
  .v-card__actions {
    border-top: 1px solid var(--v-background-lighten4);
  }
}
.fb-error-dialog-message {
  white-space: pre-wrap;
}
.fb-error-dialog-link {
  display: block;
  text-align: center;
  font-weight: bold;
}
.submit-idea-link {
  i {
    font-size: 20px;
  }
  .help-text {
    color: var(--v-text-lighten3);
    font-size: 9px;
  }
}
.leadsplus-icon {
  filter: invert(37%) sepia(48%) saturate(3407%) hue-rotate(137deg) brightness(97%) contrast(101%);
}
</style>
